export default "__VITE_ASSET__CcFI950v__"